import { render, staticRenderFns } from "./Vue.vue?vue&type=template&id=d96067da&scoped=true"
import script from "./Vue.vue?vue&type=script&lang=js"
export * from "./Vue.vue?vue&type=script&lang=js"
import style0 from "./Vue.vue?vue&type=style&index=0&id=d96067da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96067da",
  null
  
)

export default component.exports